import $ from 'jquery';

class NavMenu {
	constructor() {
		this.$nav = $('.navbar-menu-parent-link');
		this.$mainNavLink = $('.navbar-link');
		this.$navTitle = $('#navbarMenuTitle');
		this.$prevBtn = $('#navbarMenuPrevious');
		this.$menu = $('.navbar-menu-child-wrap');
		this.$searchBtn = $('#searchBtn');

		this.events();
	}

	events() {
		const that = this;

		this.$nav.on('click', function(e) {
			e.preventDefault();

			const $this = $(this),
				  $menu = $this.siblings('.navbar-menu-child-wrap');

			if ($menu.is(':hidden')) {
				that.openMenu($this, $menu);
			} else {
				that.mainMenu();
			}
		});

		this.$prevBtn.on('click', function(e) {
			e.preventDefault();

			that.mainMenu();
		});

		this.$searchBtn.on('click', function(e) {
			e.preventDefault();

			$('#searchWrap').slideToggle();
		});
	}

	openMenu($this, $menu) {
		$this.addClass('active');
		$this.slideUp();
		$menu.toggleClass('active');

		this.$nav.not(".active").hide();
		this.$mainNavLink.not('.active').hide();

		this.$prevBtn.addClass('active');
		this.$navTitle.text($this.text().replace('≈', ''));
		this.$navTitle.fadeIn();
	}

	mainMenu() {
		this.$nav.slideDown();
		this.$nav.removeClass('active');

		this.$mainNavLink.removeClass('active');
		this.$mainNavLink.fadeIn();

		this.$menu.removeClass('active');
		this.$navTitle.fadeOut();
		this.$prevBtn.removeClass('active');
	}
}

export default {
	init() {
		new NavMenu();
	}
};


// WEBPACK FOOTER //
// ./src/js/modules/navMenu.js